import { render, staticRenderFns } from "./DrawerFintscoreReportHistory.vue?vue&type=template&id=c08be2c8"
import script from "./DrawerFintscoreReportHistory.vue?vue&type=script&lang=js"
export * from "./DrawerFintscoreReportHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports